// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2_r8D","validationTips":"StatementDescriptor_validationTips__2ATB7"};